/**
 * Phase 22 — Service-worker registration.
 *
 * Called once from `src/index.js` after the React tree mounts. The
 * worker file lives at `/service-worker.js` (CRA serves
 * `public/service-worker.js` at root).
 *
 * On a new SW activating, we don't auto-reload — disruptive — but we
 * dispatch a `circleo:sw-update-ready` window event. A future toast
 * component can listen for this and offer "Reload to update".
 *
 * This module is a no-op when:
 *   - the browser doesn't support Service Worker (older Safari, etc.)
 *   - we're running on `localhost` over HTTP (some dev setups)
 *   - the user has explicitly opted out via `localStorage`
 */

export default function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (window.localStorage?.getItem('circleo.sw.disabled') === '1') return;

  // Defer registration until after first paint to avoid contending with
  // initial bundle download on slow networks.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        // Watch for an updated worker becoming available.
        reg.addEventListener('updatefound', () => {
          const incoming = reg.installing;
          if (!incoming) return;
          incoming.addEventListener('statechange', () => {
            if (
              incoming.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              window.dispatchEvent(new CustomEvent('circleo:sw-update-ready'));
            }
          });
        });
      })
      .catch(() => {
        // Registration failures are non-fatal — the app works without SW.
      });
  });
}
